// src/components/Product/ProductCard/DiscountBadge.js
import React from 'react';
import { Box } from '@mui/material';

const DiscountBadge = ({ discountText, hasDiscount, isMobile }) => {
  if (!hasDiscount || !discountText) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: isMobile ? 8 : 12,
        left: isMobile ? 8 : 12,
        bgcolor: '#ff4444',
        color: '#fff',
        px: isMobile ? 1 : 1.5,
        py: isMobile ? 0.3 : 0.5,
        borderRadius: 2,
        fontSize: isMobile ? '0.65rem' : '0.75rem',
        fontWeight: 'bold',
        zIndex: 3,
        // Adjust width for ranges
        minWidth: 'auto',
        textAlign: 'center',
        whiteSpace: 'nowrap'
      }}
    >
      {discountText}-
    </Box>
  );
};

export default DiscountBadge;
